import Tibbits from '@appblocks/codegeneration/Tibbits';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    BlockType,
    CodeBlock,
    Define,
    SettingType,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';

export default class Tibbit_26 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_26';
        this.name = 'Tibbit 26';

        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/tibbits/tbt26/IR_Remote_bitmap.bin',
            'libraries/tibbits/tbt26/tbt26.tbh',
            'libraries/tibbits/tbt26/tbt26.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];

        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                default: '',
                required: true,
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDefines(): Array<Define> {
        const currentSocket = Number(this.getSettingValue('SOCKET')).toString();
        const defines: Array<Define> = [
            {
                name: 'TBT26_SPI_CS',
                value: Tibbits.getSocketPins(currentSocket, this.project.device.id)[0],
            },
            {
                name: 'TBT26_SPI_CLK',
                value: Tibbits.getSocketPins(currentSocket, this.project.device.id)[1],
            },
            {
                name: 'TBT26_SPI_MOSI',
                value: Tibbits.getSocketPins(currentSocket, this.project.device.id)[2],
            },
            {
                name: 'TBT26_SPI_MISO',
                value: Tibbits.getSocketPins(currentSocket, this.project.device.id)[3],
            },
            {
                name: 'IR_DEBUG_PRINT',
                value: '1',
            },
        ];
        return defines;
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const currentSocket = Number(this.getSettingValue('SOCKET'));
        const NAME = this.getSettingValue('NAME');
        const { project } = this;
        const ID = this.getID();
        const socket = this.getSettingValue('SOCKET');
        const connectedSocket = (Number(socket) - 1).toString();
        const CS_LINE = Tibbits.getSocketPins(socket, project.device.id)[0];
        const MISO_LINE = Tibbits.getSocketPins(socket, project.device.id)[3];
        const MOSI_LINE = Tibbits.getSocketPins(socket, project.device.id)[2];
        const CLK_LINE = Tibbits.getSocketPins(socket, project.device.id)[1];

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${NAME}_channel as byte`,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `
dim ${NAME}_channel as byte=255`,
        });

        blocks.push({
            location: 'GLOBAL_DEFINES',
            blockType: BlockType.CODE,
            template: `
#define ${NAME}_CS ${CS_LINE}`,
        });

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'Tibbit 26 setup on socket ${connectedSocket}
    select case tbt26_init("${NAME}_IR", ${MISO_LINE}, ${MOSI_LINE}, ${CLK_LINE}, ${NAME}_CS, ${NAME}_channel)
    case TBT26_INIT_FAILURE:
        sys.debugprint("Tibbit initialization failure.")
    case TBT26_NO_SSI_AVAILABLE:
        sys.debugprint("SSI channel could not be allocated. Execution halted.")
        pat.play("R~",PL_PAT_CANINT)
        while 1
        wend
    end select
    `,
        });

        return blocks;
    }
}
